import { classNames } from "primereact/utils";
import { IconType } from "../../../../icons/Icon";
import { IconButton } from "../../../button/iconButton/IconButton";
import { RenderWhen } from "../../../../infrastructure/components/RenderWhen";
import { IGoal } from "../../models/goalModels";
import styles from "./GoalRow.module.scss";

interface IGoalRowProps {
  goal: IGoal;
  isSubGoal?: boolean;
  /** Staff controls (add sub-goal, reorder sub-goals, edit, delete); hidden for the client. */
  canEdit: boolean;
  onToggle: (goal: IGoal) => void;
  onAddSubGoal?: (goal: IGoal) => void;
  onReorderSubGoals?: (goal: IGoal) => void;
  onEdit?: (goal: IGoal) => void;
  onDelete?: (goal: IGoal) => void;
}

const ICON_SIZE = "18px";

/** One goal or sub-goal: its checkbox, its full text and, for staff, its controls. */
export const GoalRow = ({
  goal,
  isSubGoal = false,
  canEdit,
  onToggle,
  onAddSubGoal,
  onReorderSubGoals,
  onEdit,
  onDelete,
}: IGoalRowProps) => {
  return (
    <div
      className={classNames(styles.row, {
        [styles.row_sub]: isSubGoal,
        [styles.row_done]: goal.isCompleted,
      })}
    >
      <button
        type="button"
        role="checkbox"
        aria-checked={goal.isCompleted}
        aria-label={goal.text}
        className={styles.row_check}
        onClick={() => onToggle(goal)}
      >
        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" aria-hidden="true">
          <path
            d="M5 12.5l4.5 4.5L19 7.5"
            stroke="currentColor"
            strokeWidth="3"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      </button>

      <span className={styles.row_text}>{goal.text}</span>

      <RenderWhen condition={canEdit}>
        <div className={styles.row_actions}>
          <RenderWhen condition={!isSubGoal}>
            <IconButton
              iconType={IconType.Plus2}
              iconWidth={ICON_SIZE}
              iconHeight={ICON_SIZE}
              ariaLabel="Добави подцел"
              tooltip="Добави подцел"
              onClick={() => onAddSubGoal?.(goal)}
            />
          </RenderWhen>
          <RenderWhen condition={!isSubGoal && goal.subGoals.length > 1}>
            <IconButton
              iconType={IconType.DragHandle}
              iconWidth={ICON_SIZE}
              iconHeight={ICON_SIZE}
              ariaLabel="Подреди подцелите"
              tooltip="Подреди подцелите"
              onClick={() => onReorderSubGoals?.(goal)}
            />
          </RenderWhen>
          <IconButton
            iconType={IconType.EditIcon}
            iconWidth={ICON_SIZE}
            iconHeight={ICON_SIZE}
            ariaLabel="Редактирай"
            tooltip="Редактирай"
            onClick={() => onEdit?.(goal)}
          />
          <IconButton
            iconType={IconType.DeleteIcon}
            iconWidth={ICON_SIZE}
            iconHeight={ICON_SIZE}
            ariaLabel="Изтрий"
            tooltip="Изтрий"
            onClick={() => onDelete?.(goal)}
          />
        </div>
      </RenderWhen>
    </div>
  );
};
